import { Skeleton } from "@headerhawk/ui";
import { UsageMeter } from "./usage-meter";
import { useUsage } from "@/lib/hooks/use-usage";
import { isDemoTab } from "@/lib/auth/impersonation";

interface ConnectedUsageMeterProps {
  compact?: boolean;
}

/**
 * Usage meter connected to the usage data hook.
 * Shows a skeleton while loading.
 */
export function ConnectedUsageMeter({
  compact = false,
}: ConnectedUsageMeterProps) {
  const { data, isLoading, isError } = useUsage();

  // The demo's history was seeded, never charged, so its meter would count
  // a few hours of traffic against a plan nobody watching holds (task 453).
  if (isDemoTab()) return null;

  if (isLoading) {
    return (
      <div className="space-y-2">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-2 w-full" />
        <Skeleton className="h-3 w-32" />
      </div>
    );
  }

  // Don't show if error or no data
  if (isError || !data) {
    return null;
  }

  return (
    <UsageMeter
      reportCount={data.reportCount}
      limit={data.limit}
      percentUsed={data.percentUsed}
      periodStart={data.periodStart}
      periodEnd={data.periodEnd}
      status={data.status}
      compact={compact}
    />
  );
}
